import { gql } from "@apollo/client";
import {
  AvailabilityFragment,
  BlockedPeriodFragment, PatientFragment
} from "../../queries/user.qql";

export const GET_PATIENT = gql`
  query getPatient($id: Int!) {
    patient(id: $id) {
      oncologist {
        appointments {
          id
          start_at
          is_paid
        }
        blockedPeriods {
          ...BlockedPeriodFragment
        }
        availabilities {
          ...AvailabilityFragment
        }
      }
      nutrizionist {
        appointments {
          id
          start_at
          is_paid
        }
        availabilities {
          ...AvailabilityFragment
        }
        blockedPeriods {
          ...BlockedPeriodFragment
        }
      }
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
`;

export const GET_ONCOLOGIST = gql`
  query getOncologist($id: Int!) {
    oncologist(id: $id) {
      appointments {
        id
        start_at
        is_paid
        patient {
          ...PatientFragment
        }
      }
      availabilities {
        ...AvailabilityFragment
      }
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
  ${PatientFragment}
`;

export const GET_NUTRIZIONIST = gql`
  query getNutrizionist($id: Int!) {
    nutrizionist(id: $id) {
      appointments {
        id
        start_at
        is_paid
        patient {
          ...PatientFragment
        }
      }
      availabilities {
        ...AvailabilityFragment
      }
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
  ${PatientFragment}
`;

export const userQuery = {
  "patient": GET_PATIENT,
  "oncologist": GET_ONCOLOGIST,
  "nutrizionist": GET_NUTRIZIONIST,
};
